/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Address {
	openbareRuimteNaam: string;
	korteNaam?: string;
	huisnummer: number;
	huisnummertoevoeging?: string;
	huisletter?: string;
	postcode?: string;
	woonplaatsNaam: string;
	nummeraanduidingIdentificatie?: string;
	adresseerbaarObjectIdentificatie?: string;
	adresregel5?: string;
	adresregel6?: string;
	oppervlakte?: number;
	oorspronkelijkBouwjaar?: string[];
	gebruiksdoelen?: string[];
	_embedded?: {
		panden?: {
			pand: {
				identificatie: string;
				oorspronkelijkBouwjaar?: string;
			};
		}[];
	};
}

export interface Agency {
	/** @maxLength 255 */
	name: string;
	mainColor: any;
	afmNumber: string | null;
	emailAddress: string | null;
	website: string | null;
	phoneNumber: string | null;
	hdnNodeKvkNumber: string | null;
	hdnNodeZipCode: string | null;
	hdnNodeNumberForVerification: string | null;
	hdnNodeNumber: string | null;
	datakeeperTenantId: string | null;
	datakeeperTenantActivatedAt: string | null;
	financingDefaults:
		| ((string | number | boolean | null) | any[] | Record<string, any>)
		| null;
	/** @format uuid */
	id: string;
	creationDate: string;
	/**
	 * @min -2147483648
	 * @max 2147483647
	 */
	dossierCount: number;
	/**
	 * @min -2147483648
	 * @max 2147483647
	 */
	conversationCount: number;
}

export interface BaseNotification {
	message: string;
	description?: string;
}

export interface CreateLoanOffer {
	type: "preliminary" | "final";
	passingDate: string | null;
	acceptanceDate: string | null;
	extensionPossible: boolean | null;
	mustReturnSignedCopy: boolean | null;
	/** @format uuid */
	loanApplicationId: string;
	description: {
		TekstRegel: string;
		TekstRegel2?: string;
		TekstRegel3?: string;
		TekstRegel4?: string;
		TekstRegel5?: string;
	} | null;
}

export interface DocumentSendNotification {
	message: string;
	description?: string;
	/** @format uuid */
	requestedDocumentId: string;
	/** @format uuid */
	loanApplicationId: string;
}

export interface Dossier {
	/** @maxLength 255 */
	name: string;
	/** @format uuid */
	agencyId: string;
	/** @format uuid */
	id: string;
	displayId: number | null;
	creationDate: string;
	lastOpened: string | null;
	createdBy: string | null;
	dossierOwner: string | null;
}

export interface GenericDocument {
	filename: string;
	contentType: string;
	byteSize: number;
	/** @format date-time */
	creationDate: string;
	uploadedAt: string | null;
	id: string;
	url: string;
}

export interface HdnLoanApplicationSchema {
	messageType: string;
	receiverId: string;
	schemaVersion: string;
	majorVersion: string;
	startingDate: string;
	xsdJson: any;
	shouldFetch: boolean;
	createdAt: string;
	/**
	 * @min -2147483648
	 * @max 2147483647
	 */
	id: number;
}

export interface HdnNotification {
	message: string;
	notification_recipient: string;
	link: {
		href: string;
		rel: string;
		type: string;
	};
}

export interface HdnRequestedDocument {
	/** @format uuid */
	id: string;
	/** @format uuid */
	agencyId: string;
	/** @format uuid */
	hdnLoanApplicationId: string;
	documentType: string;
	documentTypeDescription: string | null;
	documentMijNr: string;
	statusmelding: string | null;
	statusmeldingDescription: string | null;
	statusmeldingDatum: string | null;
	partijNawData: PartijNAWData | null;
	linkedDocumentAction: {
		changedBy: string;
		changedAt: string;
		documentId: string | null;
	} | null;
	sentDocumentAction: {
		changedBy: string;
		changedAt: string;
		documentId: string | null;
	} | null;
	documentStatus: {
		status: string;
		description: string | null;
		createdAt: string;
	} | null;
	ketenpartijStatus: {
		status: string;
		description: string | null;
		createdAt: string;
	} | null;
}

export interface Lender {
	name: string;
	label: string;
	logo: string | null;
	icon: string | null;
	receiverCode: string | null;
}

export type LoanApplicationDetails = {
	createdAt: string;
	kenmerk: string | null;
	/** @format uuid */
	hdnDossierId: string;
	/** @format uuid */
	dossierId: string;
	/** @format uuid */
	agencyId: string;
	/** @format uuid */
	id: string;
	status: string | null;
	statusMessage: string | null;
	lenderCode: string | null;
	receiverCode: string | null;
	serviceProviderId: string | null;
	hdnId: string | null;
	currentLoanApplicationVersion: number | null;
} & {
	hdnDossier: {
		status: string | null;
		statusMessage: string | null;
		statusTimestamp: string | null;
		kind: string;
		providerCode: string | null;
		receiverCode: string;
		serviceProviderId: string | null;
		createdAt: string;
		/**
		 * @min -2147483648
		 * @max 2147483647
		 */
		requestVersion: number;
		hdnRequestTraceNr: string;
		hdnId: string | null;
		/** @format uuid */
		dossierId: string;
		/** @format uuid */
		agencyId: string;
		/** @format uuid */
		id: string;
	};
	lender: Lender;
};

export interface LoanApplicationKeyInformation {
	label: string;
	value: string | null;
}

export interface LoanApplicationMessage {
	messageType: string;
	sentAt: string;
	messageStatus: string | null;
	properties:
		| {
				type: "preliminary" | "final";
		  }
		| {
				status: string;
				statusDate: string;
				text:
					| {
							severity: string | null;
							text: string;
					  }[]
					| null;
				fromDate: string | null;
				submissionMoment: string | null;
				extension: null;
				passageData: null;
		  }
		| null;
	sentOrReceived: "sent" | "received";
}

export interface LoanApplicationNotification {
	message: string;
	description?: string;
	/** @format uuid */
	loanApplicationId: string;
}

export interface LoanApplicationPossibleActions {
	edit: boolean;
	revise: boolean;
	send: boolean;
}

export interface LoanApplicationSummary {
	formIssues: Record<string, number>;
	actions: {
		edit: boolean;
		revise: boolean;
		send: boolean;
	};
	sentAt: string | null;
}

export interface LoanOfferLenderDescription {
	TekstRegel: string;
	TekstRegel2?: string;
	TekstRegel3?: string;
	TekstRegel4?: string;
	TekstRegel5?: string;
}

export interface Notification {
	/** @format uuid */
	id: string;
	/** @format date-time */
	createdAt: string;
	type: NotificationTypes;
	/** @format uuid */
	recipientUserId: string;
	metadata:
		| LoanApplicationNotification
		| BaseNotification
		| DocumentSendNotification;
	read: boolean;
}

export interface NotificationMetadataTypes {
	generic: BaseNotification;
	loanApplication: LoanApplicationNotification;
	DocumentSendSuccess: DocumentSendNotification;
	DocumentSendError: DocumentSendNotification;
	ApplicationSendSuccess: LoanApplicationNotification;
	ApplicationSendError: LoanApplicationNotification;
}

export type NotificationTypes =
	| "generic"
	| "loanApplication"
	| "DocumentSendSuccess"
	| "DocumentSendError"
	| "ApplicationSendSuccess"
	| "ApplicationSendError";

export interface PartijNAWData {
	givenNames: string | null;
	birthInsert: string | null;
	birthSurname: string | null;
	correspondenceFirstname: string | null;
	correspondenceInsert: string | null;
	correspondenceSurname: string | null;
	initials: string | null;
	birthDate: string | null;
}

export interface ReadLoanOffer {
	/** @format uuid */
	id: string;
	type: "preliminary" | "final";
	passingDate: string | null;
	acceptanceDate: string | null;
	extensionPossible: boolean | null;
	description: {
		TekstRegel: string;
		TekstRegel2?: string;
		TekstRegel3?: string;
		TekstRegel4?: string;
		TekstRegel5?: string;
	} | null;
	mustReturnSignedCopy: boolean | null;
}

export type ReadOfferDocument = {
	docSoort: string;
	docSoortOmschrijving: string | null;
} & GenericDocument;

export interface ValidationError {
	message: string;
	/** The error code, starting with either 'xsd/' or 'xml/' */
	code: string;
	jsonPath?: string;
}

/** A version (scenario) of a dossier */
export interface Version {
	name: string | null;
	lastEdited: string | null;
	versionData: any;
	/** @format uuid */
	id: string;
	creationDate: string;
}

export interface Conversation {
	title: string | null;
	generatedTitle: string | null;
	displayId: number | null;
	durationInSeconds: number | null;
	summary: string | null;
	status: string;
	recordingId: string | null;
	type: string;
	createdAt: string;
	createdBy: string | null;
	/** @format uuid */
	id: string;
	/** @format uuid */
	agencyId: string;
	dossierId: string | null;
	transcriptionResult:
		| ((string | number | boolean | null) | any[] | Record<string, any>)
		| null;
}

export type DossierDocument = {
	filename: string;
	contentType: string;
	byteSize: number;
	/** @format date-time */
	creationDate: string;
	uploadedAt: string | null;
	id: string;
	url: string;
} & {
	dossierId: string | null;
	agencyId: string | null;
	type: "user_upload" | "hdn_received" | "interest_sheet" | "meeting_recording";
};

export interface InterestAggregation {
	products: {
		interestRate: number;
		productId: number;
		fixedInterestPeriod: number;
		repaymentForm: string;
		product: string;
		lenderName: string;
		lenderId: number;
	}[];
	lenderName: string;
	lenderId: number;
	lenderLogo: string | null;
	hdnProviderCode?: string;
	hdnProductCode?: string;
}

export interface InterestProduct {
	interestRate: number;
	productId: number;
	fixedInterestPeriod: number;
	repaymentForm: string;
	product: string;
	lenderName: string;
	lenderId: number;
}

export interface User {
	fullName: string | null;
	emailAddress: string | null;
	accountId: string | null;
	role: "api" | "customer" | "intermediary" | "admin" | "transcription";
	agencyId: string | null;
	/** @format uuid */
	id: string;
	firebaseId: string | null;
	verifiedAt: string | null;
	creationDate: string;
}

export interface VersionData {
	data: Record<string, any>;
	version: string;
}

export interface VersionNotes {
	/** @format uuid */
	versionId: string;
	changedBy: string | null;
	notes: string | null;
	/** @format date-time */
	lastChanged: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseFormat;
	/** request body */
	body?: unknown;
	/** base url */
	baseUrl?: string;
	/** request cancellation token */
	cancelToken?: CancelToken;
}

export type RequestParams = Omit<
	FullRequestParams,
	"body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
	baseUrl?: string;
	baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
	securityWorker?: (
		securityData: SecurityDataType | null,
	) => Promise<RequestParams | void> | RequestParams | void;
	customFetch?: typeof fetch;
}

export interface HttpResponse<
	D extends unknown,
	E extends unknown = unknown,
> extends Response {
	data: D;
	error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
	Json = "application/json",
	JsonApi = "application/vnd.api+json",
	FormData = "multipart/form-data",
	UrlEncoded = "application/x-www-form-urlencoded",
	Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
	public baseUrl: string = "";
	private securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
	private abortControllers = new Map<CancelToken, AbortController>();
	private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
		fetch(...fetchParams);

	private baseApiParams: RequestParams = {
		credentials: "same-origin",
		headers: {},
		redirect: "follow",
		referrerPolicy: "no-referrer",
	};

	constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
		Object.assign(this, apiConfig);
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	protected encodeQueryParam(key: string, value: any) {
		const encodedKey = encodeURIComponent(key);
		return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
	}

	protected addQueryParam(query: QueryParamsType, key: string) {
		return this.encodeQueryParam(key, query[key]);
	}

	protected addArrayQueryParam(query: QueryParamsType, key: string) {
		const value = query[key];
		return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
	}

	protected toQueryString(rawQuery?: QueryParamsType): string {
		const query = rawQuery || {};
		const keys = Object.keys(query).filter(
			(key) => "undefined" !== typeof query[key],
		);
		return keys
			.map((key) =>
				Array.isArray(query[key])
					? this.addArrayQueryParam(query, key)
					: this.addQueryParam(query, key),
			)
			.join("&");
	}

	protected addQueryParams(rawQuery?: QueryParamsType): string {
		const queryString = this.toQueryString(rawQuery);
		return queryString ? `?${queryString}` : "";
	}

	private contentFormatters: Record<ContentType, (input: any) => any> = {
		[ContentType.Json]: (input: any) =>
			input !== null && (typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.JsonApi]: (input: any) =>
			input !== null && (typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.Text]: (input: any) =>
			input !== null && typeof input !== "string"
				? JSON.stringify(input)
				: input,
		[ContentType.FormData]: (input: any) => {
			if (input instanceof FormData) {
				return input;
			}

			return Object.keys(input || {}).reduce((formData, key) => {
				const property = input[key];
				formData.append(
					key,
					property instanceof Blob
						? property
						: typeof property === "object" && property !== null
							? JSON.stringify(property)
							: `${property}`,
				);
				return formData;
			}, new FormData());
		},
		[ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
	};

	protected mergeRequestParams(
		params1: RequestParams,
		params2?: RequestParams,
	): RequestParams {
		return {
			...this.baseApiParams,
			...params1,
			...(params2 || {}),
			headers: {
				...(this.baseApiParams.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	protected createAbortSignal = (
		cancelToken: CancelToken,
	): AbortSignal | undefined => {
		if (this.abortControllers.has(cancelToken)) {
			const abortController = this.abortControllers.get(cancelToken);
			if (abortController) {
				return abortController.signal;
			}
			return void 0;
		}

		const abortController = new AbortController();
		this.abortControllers.set(cancelToken, abortController);
		return abortController.signal;
	};

	public abortRequest = (cancelToken: CancelToken) => {
		const abortController = this.abortControllers.get(cancelToken);

		if (abortController) {
			abortController.abort();
			this.abortControllers.delete(cancelToken);
		}
	};

	public request = async <T = any, E = any>({
		body,
		secure,
		path,
		type,
		query,
		format,
		baseUrl,
		cancelToken,
		...params
	}: FullRequestParams): Promise<HttpResponse<T, E>> => {
		const secureParams =
			((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
				this.securityWorker &&
				(await this.securityWorker(this.securityData))) ||
			{};
		const requestParams = this.mergeRequestParams(params, secureParams);
		const queryString = query && this.toQueryString(query);
		const payloadFormatter = this.contentFormatters[type || ContentType.Json];
		const responseFormat = format || requestParams.format;

		return this.customFetch(
			`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
			{
				...requestParams,
				headers: {
					...(requestParams.headers || {}),
					...(type && type !== ContentType.FormData
						? { "Content-Type": type }
						: {}),
				},
				signal:
					(cancelToken
						? this.createAbortSignal(cancelToken)
						: requestParams.signal) || null,
				body:
					typeof body === "undefined" || body === null
						? null
						: payloadFormatter(body),
			},
		).then(async (response) => {
			const r = response as HttpResponse<T, E>;
			r.data = null as unknown as T;
			r.error = null as unknown as E;

			const responseToParse = responseFormat ? response.clone() : response;
			const data = !responseFormat
				? r
				: await responseToParse[responseFormat]()
						.then((data) => {
							if (r.ok) {
								r.data = data;
							} else {
								r.error = data;
							}
							return r;
						})
						.catch((e) => {
							r.error = e;
							return r;
						});

			if (cancelToken) {
				this.abortControllers.delete(cancelToken);
			}

			if (!response.ok) throw data;
			return data;
		});
	};
}

/**
 * @title LoanLink Backend
 * @version 0.1.0
 */
export class LoanLinkApi<
	SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
	address = {
		/**
		 * No description
		 *
		 * @tags address
		 * @name GetAddress
		 * @request GET:/address/
		 */
		getAddress: (
			query: {
				q: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					result?: Address[];
				},
				any
			>({
				path: `/address/`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags address
		 * @name AddressList
		 * @request GET:/address/{id}/
		 */
		addressList: (id: string, params: RequestParams = {}) =>
			this.request<
				{
					address: {
						openbareRuimteNaam: string;
						korteNaam?: string;
						huisnummer: number;
						huisnummertoevoeging?: string;
						huisletter?: string;
						postcode?: string;
						woonplaatsNaam: string;
						nummeraanduidingIdentificatie?: string;
						adresseerbaarObjectIdentificatie?: string;
						adresregel5?: string;
						adresregel6?: string;
						oppervlakte?: number;
						oorspronkelijkBouwjaar?: string[];
						gebruiksdoelen?: string[];
						_embedded?: {
							panden?: {
								pand: {
									identificatie: string;
									oorspronkelijkBouwjaar?: string;
								};
							}[];
						};
					};
					wozWaarden:
						| {
								peildatum: string;
								vastgesteldeWaarde: number;
						  }[]
						| null;
					energyLabel:
						| {
								Registratiedatum: string;
								Opnamedatum: string;
								Geldig_tot: string;
								Certificaathouder: string;
								Soort_opname?: string;
								Status?: string;
								Berekeningstype: string;
								IsVereenvoudigdLabel?: boolean;
								Op_basis_van_referentiegebouw: boolean;
								Gebouwklasse: string;
								Gebouwtype?: string;
								Gebouwsubtype?: string;
								Postcode: string;
								Huisnummer: number;
								Huisletter?: string;
								BAGVerblijfsobjectID: string;
								BAGPandIDs?: string[];
								Bouwjaar: number;
								Gebruiksoppervlakte_thermische_zone?: number;
								Compactheid?: number;
								Energieklasse: string;
								EnergieIndex?: number;
								EnergieIndex_EMG_forfaitair?: number;
								Energiebehoefte?: number;
								PrimaireFossieleEnergie?: number;
								Aandeel_hernieuwbare_energie?: number;
								Temperatuuroverschrijding?: number;
								Warmtebehoefte?: number;
								BerekendeCO2Emissie: number;
								BerekendeEnergieverbruik: number;
						  }[]
						| {
								status: 404;
						  };
					listings: any;
				},
				| {
						/** @example 404 */
						status?: number;
						/** @example "Address not found" */
						message?: string;
						/** @example "address/not-found" */
						code?: string;
				  }
				| {
						/** @example 502 */
						status?: number;
						/** @example "Address service unavailable" */
						message?: string;
						/** @example "address/service-unavailable" */
						code?: string;
				  }
				| {
						/** @example 504 */
						status?: number;
						/** @example "Address lookup timed out" */
						message?: string;
						/** @example "address/gateway-timeout" */
						code?: string;
				  }
			>({
				path: `/address/${id}/`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	admin = {
		/**
		 * No description
		 *
		 * @tags admin
		 * @name NewCertificationDossier
		 * @request POST:/admin/new-certification-dossier
		 */
		newCertificationDossier: (
			query: {
				ownerId: string;
				dossierName: string;
				lenderCode: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					dossier: Dossier;
					loanApplication: LoanApplicationDetails;
				},
				any
			>({
				path: `/admin/new-certification-dossier`,
				method: "POST",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags admin
		 * @name GetHdnStatus
		 * @request GET:/admin/ops/hdn-status
		 */
		getHdnStatus: (params: RequestParams = {}) =>
			this.request<
				{
					status: "ok" | "degraded" | "error";
					responseTime: number;
					message: string;
					cached?: boolean;
					details?: {
						env?: string;
					};
				},
				any
			>({
				path: `/admin/ops/hdn-status`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	agency = {
		/**
		 * @description Create a new agency
		 *
		 * @tags agency
		 * @name CreateAgency
		 * @request POST:/agency/
		 */
		createAgency: (
			data: {
				/** @minLength 2 */
				agencyName: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					agency: Agency;
				},
				any
			>({
				path: `/agency/`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Update an agency
		 *
		 * @tags agency
		 * @name UpdateAgency
		 * @request POST:/agency/{agencyId}/
		 */
		updateAgency: (
			agencyId: string,
			data: {
				name?: string;
				mainColor?: {
					red: number;
					green: number;
					blue: number;
				};
				hdnNodeNumber?: string;
				hdnNodeKvkNumber?: string;
				hdnNodeZipCode?: string;
				financingDefaults?: {
					notarisLevering?: number;
					notarisHypotheek?: number;
					taxatiekosten?: number;
					kostenHypotheekadvies?: number;
				};
			},
			params: RequestParams = {},
		) =>
			this.request<Agency, any>({
				path: `/agency/${agencyId}/`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	api = {
		/**
		 * No description
		 *
		 * @tags api
		 * @name Onboard
		 * @request POST:/api/onboard/
		 */
		onboard: (
			data: {
				/** The name of the intermediary which should own the dossier. */
				intermediaryName: string;
				/** @format email */
				customerEmail: string;
				/** Full name of the new user */
				customerName: string;
				/**
				 * The id of the agency to which to add the user and dossier to.
				 * @format uuid
				 */
				agencyId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					status: 200;
					message: string;
					/** @format uuid */
					dossierId?: string;
					isExisting?: boolean;
				},
				any
			>({
				path: `/api/onboard/`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags datakeeper
		 * @name DatakeeperCallback
		 * @request POST:/api/v1/datakeeper/callback
		 */
		datakeeperCallback: (
			data:
				| {
						version: "1";
						event: "SESSION_STATUS_UPDATE";
						eventData: {
							userId: string;
							trxId: string;
						};
				  }
				| {
						version: "1.0";
						event: "DELEGATED_TENANT_STATUS_CHANGE";
						eventData: {
							delegatedTenantId: string;
						};
				  },
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/api/v1/datakeeper/callback`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),
	};
	conversation = {
		/**
		 * No description
		 *
		 * @tags conversation
		 * @name GetTranscriptionToken
		 * @request GET:/conversation/token
		 */
		getTranscriptionToken: (params: RequestParams = {}) =>
			this.request<
				{
					secret: {
						key: string;
						expiresAt: number;
						type: "speechmatics";
					};
				},
				any
			>({
				path: `/conversation/token`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags conversation
		 * @name EditConversationSummary
		 * @request PUT:/conversation/{conversationId}/summary
		 */
		editConversationSummary: (
			conversationId: string,
			data: {
				summary: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					success: boolean;
				},
				any
			>({
				path: `/conversation/${conversationId}/summary`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags conversation
		 * @name GetConversationSummaryHistory
		 * @request GET:/conversation/{conversationId}/summary/history
		 */
		getConversationSummaryHistory: (
			conversationId: string,
			params: RequestParams = {},
		) =>
			this.request<
				{
					id: string;
					conversationId: string;
					diff: string;
					editedBy: string | null;
					createdAt: string;
					editor: {
						id: string;
						emailAddress: string | null;
						fullName: string | null;
					} | null;
				}[],
				any
			>({
				path: `/conversation/${conversationId}/summary/history`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	dataRequest = {
		/**
		 * No description
		 *
		 * @tags data-request
		 * @name DataRequestAuthenticate
		 * @request PUT:/data-request/{dataRequestId}/authenticate
		 */
		dataRequestAuthenticate: (
			dataRequestId: string,
			data: {
				token: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/data-request/${dataRequestId}/authenticate`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),
	};
	document = {
		/**
		 * @description Get a single document by id
		 *
		 * @tags document
		 * @name ClassifyDocument
		 * @request POST:/document/{documentId}/classify
		 */
		classifyDocument: (
			documentId: string,
			data: {
				classification: {
					label: string;
					confidence: number;
					pageCount?: number;
					classifiedBy: string;
					extractionResult?: any;
				};
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/document/${documentId}/classify`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * @description Get extraction result for a classified document
		 *
		 * @tags document
		 * @name GetDocumentExtraction
		 * @request GET:/document/{documentId}/extraction
		 */
		getDocumentExtraction: (
			documentId: string,
			query?: {
				label?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					extractionResult: any;
				},
				any
			>({
				path: `/document/${documentId}/extraction`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * @description Get a single document token by id
		 *
		 * @tags document
		 * @name GetDocumentToken
		 * @request GET:/document/{documentId}/token
		 */
		getDocumentToken: (documentId: string, params: RequestParams = {}) =>
			this.request<
				{
					url: string;
				},
				any
			>({
				path: `/document/${documentId}/token`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	dossier = {
		/**
		 * No description
		 *
		 * @tags dossier
		 * @name CreateDossier
		 * @request POST:/dossier/
		 */
		createDossier: (
			data: {
				/** @minLength 3 */
				dossierName: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					message: string;
					dossier: Dossier;
				},
				any
			>({
				path: `/dossier/`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Delete a dossier
		 *
		 * @tags dossier
		 * @name DeleteDossier
		 * @request DELETE:/dossier/{dossierId}/
		 */
		deleteDossier: (dossierId: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/dossier/${dossierId}/`,
				method: "DELETE",
				...params,
			}),

		/**
		 * @description Retrieve all users belonging to a given dossier
		 *
		 * @tags dossier
		 * @name RetrieveDossierUsers
		 * @request GET:/dossier/{dossierId}/access/
		 */
		retrieveDossierUsers: (dossierId: string, params: RequestParams = {}) =>
			this.request<
				User[],
				{
					/** @example 403 */
					status?: number;
					/** @example "User can only access their own data." */
					message?: string;
					/** @example "user/access-not-allowed" */
					code?: string;
				}
			>({
				path: `/dossier/${dossierId}/access/`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Apply extraction fields to dossier (server-side atomic writer)
		 *
		 * @tags dossier
		 * @name ApplyExtraction
		 * @request POST:/dossier/{dossierId}/apply-extraction/
		 */
		applyExtraction: (
			dossierId: string,
			data: {
				/** @format uuid */
				suggestionId: string;
				customerId: string;
				targetEntryId: string | null;
				createNewEntry: boolean;
				fieldsToApply: {
					extractionKey: string;
					expectedOldValue: any;
				}[];
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					auditId: string;
					fieldsApplied: number;
					createdEntryId: string | null;
				},
				| {
						message: string;
				  }
				| {
						error: string;
						conflicts: {
							extractionKey: string;
							expected: any;
							actual: any;
						}[];
				  }
			>({
				path: `/dossier/${dossierId}/apply-extraction/`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Retrieve all documents that were uploaded in a certain dossier.
		 *
		 * @tags dossier
		 * @name GetDossierDocuments
		 * @request GET:/dossier/{dossierId}/documents/
		 */
		getDossierDocuments: (dossierId: string, params: RequestParams = {}) =>
			this.request<
				{
					documents: DossierDocument[];
				},
				any
			>({
				path: `/dossier/${dossierId}/documents/`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Get a single document by id
		 *
		 * @tags dossier
		 * @name GetDossierDocument
		 * @request GET:/dossier/{dossierId}/documents/{documentId}/
		 */
		getDossierDocument: (
			dossierId: string,
			documentId: string,
			params: RequestParams = {},
		) =>
			this.request<
				{
					document: DossierDocument;
				},
				any
			>({
				path: `/dossier/${dossierId}/documents/${documentId}/`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Get a single document upload url
		 *
		 * @tags dossier
		 * @name GetDocumentUploadUrl
		 * @request GET:/dossier/{dossierId}/documents/{documentId}/upload-url
		 */
		getDocumentUploadUrl: (
			dossierId: string,
			documentId: string,
			params: RequestParams = {},
		) =>
			this.request<
				{
					uploadUrl: string;
				},
				any
			>({
				path: `/dossier/${dossierId}/documents/${documentId}/upload-url`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags dossier
		 * @name DuplicateDossier
		 * @request POST:/dossier/{dossierId}/duplicate
		 */
		duplicateDossier: (dossierId: string, params: RequestParams = {}) =>
			this.request<
				{
					message: string;
					dossier: Dossier;
				},
				any
			>({
				path: `/dossier/${dossierId}/duplicate`,
				method: "POST",
				format: "json",
				...params,
			}),

		/**
		 * @description Get source traces for extraction-applied fields
		 *
		 * @tags dossier
		 * @name GetExtractionSourceTraces
		 * @request GET:/dossier/{dossierId}/extraction-source-traces/
		 */
		getExtractionSourceTraces: (
			dossierId: string,
			params: RequestParams = {},
		) =>
			this.request<
				{
					traces: {
						fieldPath: string;
						customerId: string;
						targetEntryId: string | null;
						sourceDocumentName: string;
						sourceLabel: string;
						appliedAt: string;
						appliedBy: string;
					}[];
				},
				any
			>({
				path: `/dossier/${dossierId}/extraction-source-traces/`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description List extraction suggestions for a dossier
		 *
		 * @tags dossier
		 * @name GetDossierExtractionSuggestions
		 * @request GET:/dossier/{dossierId}/extraction-suggestions/
		 */
		getDossierExtractionSuggestions: (
			dossierId: string,
			params: RequestParams = {},
		) =>
			this.request<
				{
					suggestions: {
						id: string;
						documentId: string;
						documentName: string | null;
						classificationLabel: string;
						sectionType: string;
						matchedCustomerId: string | null;
						matchSource: string;
						matchConfidence: number;
						status: string;
						reactivatedAfterDelete?: boolean;
						createdAt: string;
					}[];
				},
				any
			>({
				path: `/dossier/${dossierId}/extraction-suggestions/`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Update extraction suggestion status
		 *
		 * @tags dossier
		 * @name UpdateExtractionSuggestion
		 * @request PATCH:/dossier/{dossierId}/extraction-suggestions/{suggestionId}
		 */
		updateExtractionSuggestion: (
			dossierId: string,
			suggestionId: string,
			data: {
				status: "bekeken" | "genegeerd";
				dismissReason?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					id: string;
					status: string;
				},
				{
					message: string;
				}
			>({
				path: `/dossier/${dossierId}/extraction-suggestions/${suggestionId}`,
				method: "PATCH",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Retrieve all users that can be set as dossier owner
		 *
		 * @tags dossier
		 * @name GetDossierUsersAvaibleAsOwner
		 * @request GET:/dossier/{dossierId}/owner/available
		 */
		getDossierUsersAvaibleAsOwner: (
			dossierId: string,
			params: RequestParams = {},
		) =>
			this.request<
				{
					users: {
						fullName: string | null;
						emailAddress: string | null;
						accountId: string | null;
						role:
							| "api"
							| "customer"
							| "intermediary"
							| "admin"
							| "transcription";
						agencyId: string | null;
						/** @format uuid */
						id: string;
						firebaseId: string | null;
						verifiedAt: string | null;
						creationDate: string;
					}[];
				},
				any
			>({
				path: `/dossier/${dossierId}/owner/available`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Retrieve all versions of a dossier
		 *
		 * @tags version
		 * @name GetVersions
		 * @request GET:/dossier/{dossierId}/version/
		 */
		getVersions: (dossierId: string, params: RequestParams = {}) =>
			this.request<
				{
					status: 200;
					versions: Version[];
				},
				any
			>({
				path: `/dossier/${dossierId}/version/`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Create a new version in a dossier
		 *
		 * @tags version
		 * @name CreateVersion
		 * @request POST:/dossier/{dossierId}/version/
		 */
		createVersion: (dossierId: string, params: RequestParams = {}) =>
			this.request<
				{
					status: 201;
					/** A version (scenario) of a dossier */
					version: Version;
				},
				any
			>({
				path: `/dossier/${dossierId}/version/`,
				method: "POST",
				format: "json",
				...params,
			}),

		/**
		 * @description Retrieve a version by its ID and its dossier ID
		 *
		 * @tags version
		 * @name GetVersion
		 * @request GET:/dossier/{dossierId}/version/{versionId}/
		 */
		getVersion: (
			dossierId: string,
			versionId: string,
			params: RequestParams = {},
		) =>
			this.request<
				{
					status: 201;
					/** A version (scenario) of a dossier */
					version: Version;
				},
				any
			>({
				path: `/dossier/${dossierId}/version/${versionId}/`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Update a version
		 *
		 * @tags version
		 * @name UpdateVersion
		 * @request PUT:/dossier/{dossierId}/version/{versionId}/
		 */
		updateVersion: (
			dossierId: string,
			versionId: string,
			data: {
				versionData: VersionData;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/dossier/${dossierId}/version/${versionId}/`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),
	};
	hdn = {
		/**
		 * @description Classify the IVO requirement from the active provider control XML
		 *
		 * @tags hdn
		 * @name GetIvoStatus
		 * @request POST:/hdn/ivo-status
		 */
		getIvoStatus: (
			data: {
				messageType: string;
				receiverCode: string;
				messageVersion?: string;
				nhg?: boolean;
				productCode?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					status:
						| "requiresIvo"
						| "ivoOnlyUnderNhg"
						| "acceptsOnderneming"
						| "rejectsOnderneming"
						| "requiresIvoForProducts"
						| "unknown";
					message: string | null;
					action:
						| "convert-to-ivo"
						| "requires-nhg"
						| "choose-other-provider"
						| "none";
				},
				any
			>({
				path: `/hdn/ivo-status`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Create a HDN notification. Supposed to be called by HDN as a webhook.
		 *
		 * @tags hdn
		 * @name CreateHdnNotification
		 * @request POST:/hdn/notification
		 */
		createHdnNotification: (
			data: HdnNotification,
			params: RequestParams = {},
		) =>
			this.request<object, any>({
				path: `/hdn/notification`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get the schema for the supplied HDN message
		 *
		 * @tags hdn
		 * @name GetSchema
		 * @request POST:/hdn/schema
		 */
		getSchema: (
			data: {
				messageType: string;
				organizationCode: string;
				messageVersion?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					schema: object;
				},
				any
			>({
				path: `/hdn/schema`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	health = {
		/**
		 * No description
		 *
		 * @name HealthList
		 * @request GET:/health/
		 */
		healthList: (params: RequestParams = {}) =>
			this.request<
				{
					status: "ok";
					version: string;
					startedAt: string;
				},
				any
			>({
				path: `/health/`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	interest = {
		/**
		 * No description
		 *
		 * @tags interest
		 * @name GetOptimalInterests
		 * @request GET:/interest/
		 */
		getOptimalInterests: (
			query: {
				useNHG: boolean;
				/** @min 0 */
				ltv: number;
				bouwaard?: string;
				quotationValidForMonths?: string;
				rentevastePeriodes?: number[];
				aflossingsvormen?: string[];
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					result: InterestAggregation[];
				},
				any
			>({
				path: `/interest/`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	lender = {
		/**
		 * @description Get all lenders
		 *
		 * @tags lender
		 * @name GetAllLenders
		 * @request GET:/lender/
		 */
		getAllLenders: (params: RequestParams = {}) =>
			this.request<Lender[], any>({
				path: `/lender/`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	loanApplication = {
		/**
		 * @description Create a new loan application.
		 *
		 * @tags loan-application
		 * @name CreateApplication
		 * @request POST:/loan-application/
		 */
		createApplication: (
			data: {
				dossierId: string;
				lenderCode: string;
				version?: "25.0" | "26.0";
			},
			params: RequestParams = {},
		) =>
			this.request<LoanApplicationDetails, any>({
				path: `/loan-application/`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get a single loan application.
		 *
		 * @tags loan-application
		 * @name GetApplication
		 * @request GET:/loan-application/{loanApplicationId}/
		 */
		getApplication: (loanApplicationId: string, params: RequestParams = {}) =>
			this.request<LoanApplicationDetails, any>({
				path: `/loan-application/${loanApplicationId}/`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Get the contents of a loan application.
		 *
		 * @tags loan-application
		 * @name GetApplicationContents
		 * @request GET:/loan-application/{loanApplicationId}/contents
		 */
		getApplicationContents: (
			loanApplicationId: string,
			params: RequestParams = {},
		) =>
			this.request<
				{
					OfferteAanvraag: Record<string, any>;
				},
				any
			>({
				path: `/loan-application/${loanApplicationId}/contents`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Update the contents of a loan application.
		 *
		 * @tags loan-application
		 * @name UpdateApplicationContents
		 * @request PUT:/loan-application/{loanApplicationId}/contents
		 */
		updateApplicationContents: (
			loanApplicationId: string,
			data: {
				OfferteAanvraag: Record<string, any>;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					OfferteAanvraag: Record<string, any>;
				},
				any
			>({
				path: `/loan-application/${loanApplicationId}/contents`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get all HDN messages for a loan application.
		 *
		 * @tags loan-application
		 * @name GetApplicationMessages
		 * @request GET:/loan-application/{loanApplicationId}/messages
		 */
		getApplicationMessages: (
			loanApplicationId: string,
			params: RequestParams = {},
		) =>
			this.request<
				{
					messages: LoanApplicationMessage[];
				},
				any
			>({
				path: `/loan-application/${loanApplicationId}/messages`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Get received loan offers for the application.
		 *
		 * @tags loan-application
		 * @name GetOffers
		 * @request GET:/loan-application/{loanApplicationId}/offers
		 */
		getOffers: (loanApplicationId: string, params: RequestParams = {}) =>
			this.request<ReadLoanOffer[], any>({
				path: `/loan-application/${loanApplicationId}/offers`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Get the latest received loan offer.
		 *
		 * @tags loan-application
		 * @name GetLatestOffer
		 * @request GET:/loan-application/{loanApplicationId}/offers/latest
		 */
		getLatestOffer: (loanApplicationId: string, params: RequestParams = {}) =>
			this.request<ReadLoanOffer, any>({
				path: `/loan-application/${loanApplicationId}/offers/latest`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Get documents that belong to a loan offer.
		 *
		 * @tags loan-application
		 * @name GetOfferDocuments
		 * @request GET:/loan-application/{loanApplicationId}/offers/{offerId}/documents
		 */
		getOfferDocuments: (
			loanApplicationId: string,
			offerId: string,
			params: RequestParams = {},
		) =>
			this.request<ReadOfferDocument[], any>({
				path: `/loan-application/${loanApplicationId}/offers/${offerId}/documents`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Gets received documents in a loan application.
		 *
		 * @tags loan-application
		 * @name GetReceivedDocuments
		 * @request GET:/loan-application/{loanApplicationId}/received-documents
		 */
		getReceivedDocuments: (
			loanApplicationId: string,
			params: RequestParams = {},
		) =>
			this.request<DossierDocument[], any>({
				path: `/loan-application/${loanApplicationId}/received-documents`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Create a new revision of a loan application.
		 *
		 * @tags loan-application
		 * @name CreateApplicationRevision
		 * @request POST:/loan-application/{loanApplicationId}/revise
		 */
		createApplicationRevision: (
			loanApplicationId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/loan-application/${loanApplicationId}/revise`,
				method: "POST",
				...params,
			}),

		/**
		 * @description Get application form content schema definition.
		 *
		 * @tags loan-application
		 * @name GetApplicationContentSchema
		 * @request GET:/loan-application/{loanApplicationId}/schema
		 */
		getApplicationContentSchema: (
			loanApplicationId: string,
			params: RequestParams = {},
		) =>
			this.request<HdnLoanApplicationSchema, any>({
				path: `/loan-application/${loanApplicationId}/schema`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Submit application to HDN network.
		 *
		 * @tags loan-application
		 * @name SendApplication
		 * @request POST:/loan-application/{loanApplicationId}/send
		 */
		sendApplication: (
			loanApplicationId: string,
			query?: {
				sendWithErrors?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/loan-application/${loanApplicationId}/send`,
				method: "POST",
				query: query,
				...params,
			}),

		/**
		 * @description Get a summary of a loan application.
		 *
		 * @tags loan-application
		 * @name GetApplicationSummary
		 * @request GET:/loan-application/{loanApplicationId}/summary
		 */
		getApplicationSummary: (
			loanApplicationId: string,
			params: RequestParams = {},
		) =>
			this.request<LoanApplicationSummary, any>({
				path: `/loan-application/${loanApplicationId}/summary`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Validate the contents of a loan application.
		 *
		 * @tags loan-application
		 * @name ValidateApplicationContents
		 * @request POST:/loan-application/{loanApplicationId}/validate
		 */
		validateApplicationContents: (
			loanApplicationId: string,
			params: RequestParams = {},
		) =>
			this.request<ValidationError[], any>({
				path: `/loan-application/${loanApplicationId}/validate`,
				method: "POST",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags loan-application
		 * @name GetApplicationXml
		 * @request GET:/loan-application/{loanApplicationId}/xml
		 */
		getApplicationXml: (
			loanApplicationId: string,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/loan-application/${loanApplicationId}/xml`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	notification = {
		/**
		 * @description Get notifications for user making request.
		 *
		 * @tags notifications
		 * @name GetNotifications
		 * @request POST:/notification/
		 */
		getNotifications: (params: RequestParams = {}) =>
			this.request<Notification[], any>({
				path: `/notification/`,
				method: "POST",
				format: "json",
				...params,
			}),

		/**
		 * @description Provides realtime notification updates using Server-Send Events
		 *
		 * @tags notifications
		 * @name Listen
		 * @request GET:/notification/listen
		 */
		listen: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/notification/listen`,
				method: "GET",
				...params,
			}),

		/**
		 * @description Mark notification as read.
		 *
		 * @tags notifications
		 * @name MarkRead
		 * @request POST:/notification/{id}/read
		 */
		markRead: (id: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/notification/${id}/read`,
				method: "POST",
				...params,
			}),

		/**
		 * @description Mark notification as NOT read.
		 *
		 * @tags notifications
		 * @name MarkNotRead
		 * @request POST:/notification/{id}/unread
		 */
		markNotRead: (id: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/notification/${id}/unread`,
				method: "POST",
				...params,
			}),
	};
	tunnel = {
		/**
		 * No description
		 *
		 * @name TunnelCreate
		 * @request POST:/tunnel/
		 */
		tunnelCreate: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/tunnel/`,
				method: "POST",
				...params,
			}),
	};
	user = {
		/**
		 * @description Create a new user
		 *
		 * @tags user
		 * @name CreateUser
		 * @request POST:/user/
		 */
		createUser: (
			data: {
				/**
				 * Dossier to add the new user to
				 * @format uuid
				 */
				dossierId: string;
				customerName: string;
				customerEmail: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					/** Response message */
					message: string;
					/** Name of the customer */
					name: string;
					/**
					 * Emailaddress of the added customer
					 * @format email
					 */
					email: string;
					/** Indicates whether a new firebase user was added */
					isNewUser: boolean;
					ok: true;
				},
				| {
						/** @example 400 */
						status?: number;
						/** @example "User fields in firebase are not valid. Contact the organization to resolve the issue." */
						message?: string;
						/** @example "user/firebase-fields-invalid" */
						code?: string;
				  }
				| {
						/** @example 403 */
						status?: number;
						/** @example "User can only access their own data." */
						message?: string;
						/** @example "user/access-not-allowed" */
						code?: string;
				  }
				| {
						/** @example 404 */
						status?: number;
						/** @example "The requested dossier couldn't be found." */
						message?: string;
						/** @example "dossier/not-found" */
						code?: string;
				  }
				| {
						/** @example 409 */
						status?: number;
						/** @example "User already exists." */
						message?: string;
						/** @example "user/already-exists" */
						code?: string;
				  }
				| {
						/** @example 422 */
						status?: number;
						/** @example "The provided emailadress was invalid" */
						message?: string;
						/** @example "user/invalid-email" */
						code?: string;
				  }
			>({
				path: `/user/`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	webhooks = {
		/**
		 * @description Process incoming Postmark webhook events
		 *
		 * @tags webhooks
		 * @name ProcessPostmarkWebhook
		 * @request POST:/webhooks/postmark
		 */
		processPostmarkWebhook: (
			query?: {
				/** Authentication token for webhook access */
				token?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					status: string;
				},
				{
					error: string;
				}
			>({
				path: `/webhooks/postmark`,
				method: "POST",
				query: query,
				format: "json",
				...params,
			}),
	};
	zero = {
		/**
		 * @description Zero mutate
		 *
		 * @tags zero
		 * @name ZeroMutate
		 * @request POST:/zero/mutate
		 */
		zeroMutate: (data: Record<string, any>, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/zero/mutate`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * @description Zero query
		 *
		 * @tags zero
		 * @name ZeroQuery
		 * @request POST:/zero/query
		 */
		zeroQuery: (data: any[], params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/zero/query`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),
	};
}
